import request from "../js/request"

// 获取是否语音播报
export function getIsBroadcast(token){
  return request({
    url: '/api/User/getIsBroadcast',
    method: 'post',
    headers:{
      'userToken':token
    }
  })
}

// ai转化
export function aiConvert(param,token){
  return request({
    url: '/api/AiTool/aiConvert',
    method: 'post',
    data:param,
    headers:{
      'userToken':token
    }
  })
}

// Ai创建事项
export function addAiMatter(param,token){
  return request({
    url: '/api/AiTool/addAiMatter',
    method: 'post',
    data:param,
    headers:{
      'userToken':token
    }
  })
}

// ai小模型
export function aiSmallModel(param,token){
  return request({
    url: '/api/AiTool/aiSmallModel',
    method: 'post',
    data:param,
    headers:{
      'userToken':token
    }
  })
}

// 百度ai
export function baiduAiConvert(param,token){
  return request({
    url: '/api/AiTool/baiduAiConvert',
    method: 'post',
    data:param,
    headers:{
      'userToken':token
    }
  })
}





// WEBPACK FOOTER //
// ./src/assets/api/api.js